import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { registerUser } from '../../modules/user'

import Registration from '../../components/registration/Registration'

class RegistrationContainer extends React.Component {
  render() {
    const { registerUser, authError } = this.props
    return <Registration error={authError} onSubmit={registerUser} />
  }
}

const mapStateToProps = ({ user }) => ({
  isAuthenticating: user.isAuthenticating,
  authError: user.authError,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      registerUser,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationContainer)
